$(() => {
  const section = $('#open-positions');
  $(".bs-pro-button--scroll-to a").click(function() {
    if (section.length) {
    $('html,body').animate({
        scrollTop: $(section).offset().top - 100},
        'slow');
    }
  });
});